"use client"

import React, { useState, useEffect } from "react"
import { ArrowLeft } from "lucide-react"
import { usePathname, useRouter } from "next/navigation"

import Brand from "@packages/web/components/Brand"
import Logo from "@packages/web/components/Logo"
import NavLink from "@packages/web/components/NavLink"
import BackLink from "@packages/web/components/BackLink"

import NavMenu from "@/components/NavMenu"

export default function Header({ noBacklink }: { noBacklink?: boolean } = {}) {
  const [isScrolled, setIsScrolled] = useState(false)
  const pathname = usePathname()
  const router = useRouter()
  const isAuth = pathname === "/auth" || pathname.startsWith("/auth/")
  const showBackBesideLogo = isAuth && !noBacklink
  const showCenterBackLink = pathname.split("/").length > 2 && !noBacklink && !showBackBesideLogo

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0)
    }

    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 left-0 grid grid-cols-[1fr_auto_1fr] items-center w-full z-2001 px-2 h-(--header-height) pointer-events-none transition-all duration-300 ${isScrolled ? "shadow-sm bg-background backdrop-blur-md" : "bg-background/90"}`}
    >
      <div className="flex items-center gap-1 pointer-events-auto w-fit">
        <NavLink
          to="/"
          variant="secondary"
          aria-label="ohyai — accueil"
          className="!bg-transparent hover:!bg-transparent/80 ml-0 pl-1 w-fit"
        >
          <div className="flex items-center gap-2">
            <Logo />
            <Brand />
          </div>
        </NavLink>
        {showBackBesideLogo ? (
          <button
            type="button"
            aria-label="Retour"
            className="ml-1 inline-flex h-9 w-9 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground"
            onClick={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                router.back()
                return
              }
              router.push("/")
            }}
          >
            <ArrowLeft className="h-5 w-5" />
          </button>
        ) : null}
      </div>
      <div className="flex justify-center pointer-events-auto">
        {showCenterBackLink && <BackLink />}
      </div>
      <div className="pointer-events-auto justify-self-end">
        <NavMenu />
      </div>
    </header>
  )
}
